import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {CSSProperties} from 'react';

const styles = require('./BoxTitle.less');
const cx = classnames.bind(styles);

export interface BoxTitleProps
{
    displayName?:string;
    className?:string;
    style?:CSSProperties;
}

@observer
export class BoxTitle extends React.Component<BoxTitleProps, any>
{
    render()
    {
        const {displayName, className, style} = this.props;

        return (
            <div
                data-box-title="true"
                className={cx('boxTitle', className)}
                style={style}
            >
                {displayName}
            </div>
        );
    }
}
